import React from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AppContainer from 'components/AppContainer';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectClientDetails,
  makeSelectRegion,
} from 'containers/Main/selectors';
import _uniqBy from 'lodash/uniqBy';
import { makeSelectClientLanding } from 'containers/ClientLanding/selectors';
import ClientResources from 'components/ClientResources';
import { useQuery } from 'react-query';
import getRegionBySlug from 'containers/Main/services/getRegionBySlug.gql';
import ListTitle from 'components/ListTitle';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 50,
    backgroundColor: '#fff',
  },
  landingRoot: {
    backgroundColor: '#fff',
    marginTop: 13,
    marginBottom: 0,
  },
  cardRoot: {
    height: 'auto',
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
  },
  landingCardRoot: {
    padding: '40px 0 0',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    '& p': {
      ...theme.typography.subtitle1,
      fontFamily: 'MadaRegular',
      margin: '0 13px 0 0',
      fontWeight: 400,
    },
    '& a': {
      ...theme.typography.subtitle1,
      fontFamily: 'MadaRegular',
      fontWeight: 400,
      marginLeft: 5,
    },
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
    },
  },
  header: {
    marginBottom: 27,
  },
  titleWrapper: {
    '& h2': {
      overflow: 'hidden',
      [theme.breakpoints.up('600')]: {
        '&::after': {
          content: `""`,
          height: '0.6em',
          verticalAlign: 'bottom',
          width: '100%',
          marginRight: '-100%',
          marginLeft: 20,
          borderTop: '1px solid #E2E2E2',
          display: 'inline-block',
        },
      },
    },
  },
}));

const stateSelector = createStructuredSelector({
  clientDetails: makeSelectClientDetails(),
  region: makeSelectRegion(),
  clientLanding: makeSelectClientLanding(),
});
function ClientExclusive() {
  const { clientDetails, region, clientLanding } = useSelector(stateSelector);
  const classes = useStyles();
  const name = _get(clientDetails, 'name', '');
  const {
    title = '',
    userTerm,
    slug,
    clientResourcesCollection,
  } = clientLanding;
  const isCovidCenter = slug === 'covid-19';
  const { data } = useQuery(
    !isCovidCenter && region && ['region', region],
    getRegionBySlug,
  );
  if (_isEmpty(clientDetails)) return null;
  const clientResources = isCovidCenter
    ? _get(clientResourcesCollection, 'items', [])
    : _get(clientDetails, 'clientResourcesCollection.items', []);
  const finalTitle = `${isCovidCenter ? title : name} ${userTerm || ''}`;
  const hasMultipleLanding =
    _get(clientDetails, 'landingLinksCollection.items', []).length > 1;
  const landingClientResources = hasMultipleLanding
    ? _get(clientLanding, 'clientResourcesCollection.items', [])
    : [];
  const regionClientResources = _get(
    data,
    'clientResourcesCollection.items',
    [],
  );
  if (_isEmpty(clientResources) && _isEmpty(regionClientResources)) return null;
  const finalClientResources = _uniqBy(
    [...clientResources, ...regionClientResources, ...landingClientResources],
    'slug',
  );
  return (
    <Grid item xs={12} className={classes.root}>
      <AppContainer noPadding>
        <Grid container spacing={2} className={classes.cardRoot}>
          <Grid item xs={12} className={classes.header}>
            <Grid container direction="row" justify="space-between">
              <Grid item xs={12} className={classes.titleWrapper}>
                <ListTitle title={`${finalTitle} Resources`} />
              </Grid>
            </Grid>
          </Grid>
          <ClientResources
            data={finalClientResources}
            clientData={clientDetails}
          />
        </Grid>
      </AppContainer>
    </Grid>
  );
}

export default ClientExclusive;
